import { atom } from 'nanostores';
export const $charitableDonationsWidget = atom(false);
